import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import Table from 'components/Table'

import UnsubscribeOutlinedIcon from '@mui/icons-material/UnsubscribeOutlined'
import MailOutlinedIcon from '@mui/icons-material/MailOutlined'

import AlertNotificationCell from 'pages/AlertNotificationConfigurations/AlertNotificationCell'
import NotificationModel from 'pages/AlertNotificationConfigurations/NotificationsModel'

import Api from 'services/api'

import { CriticalAndMajorAlert, AdminNotificationsPolicy } from 'types/AdminNotificationsPolicy'
import { screenSize } from 'styles/shared'

type Props = {
    criticalAndMajorAlert: Required<CriticalAndMajorAlert>
  }

const AlertNotification = ({ criticalAndMajorAlert } : Props) => {
  const [sendStatus, setSendStatus] = useState('')
  const [enabled, setEnabled] = useState(false)
  const [showModal, setshowModal] = useState(false)
  const [alert, setAlert] = useState<AdminNotificationsPolicy>()

  const refresh = (criticalAndMajorAlert: CriticalAndMajorAlert) => {
    if (criticalAndMajorAlert.enabled) {
      setEnabled(true)
      if (criticalAndMajorAlert.occurrenceCount || criticalAndMajorAlert.occurrenceTime || criticalAndMajorAlert.activeCount) {
        setSendStatus('SEND IF')
      } else {
        setSendStatus('SEND')
      }
    } else {
      setEnabled(false)
      setSendStatus("DON'T SEND")
    }
  }

  useEffect(() => {
    refresh(criticalAndMajorAlert)
    const activeAlert : Required<AdminNotificationsPolicy> = {
      ...alert,
      ...{
        enabled: criticalAndMajorAlert.enabled,
        activeCount: criticalAndMajorAlert.activeCount,
        activeInterval: criticalAndMajorAlert.activeInterval,
        occurrenceCount: criticalAndMajorAlert.occurrenceCount,
        occurrenceInterval: criticalAndMajorAlert.occurrenceInterval,
        occurrenceTime: criticalAndMajorAlert.occurrenceTime
      }
    }

    setAlert({ ...activeAlert })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [criticalAndMajorAlert])

  const refreshSendStatus = () => {
    Api.AlertNotifications.get(criticalAndMajorAlert.code).then((res) => {
      refresh(res)
      setAlert(res)
    })
  }

  const onClose = () => {
    setshowModal(false)
    refreshSendStatus()
  }
  const onClickSend = () => {
    setshowModal(true)
  }

  return (
    <>
      {showModal && <NotificationModel code={criticalAndMajorAlert.code} alert={alert} onCloseCallBack={() => onClose()} />}
      <S.SendCell aria-label="alert" onClick={() => onClickSend()}>
        {enabled ? <S.SendMailIcon fontSize="large" /> : <S.UnSendMailIcon fontSize="large" />}
        {sendStatus}
      </S.SendCell>
      <AlertNotificationCell criticalAndMajorAlert={criticalAndMajorAlert} enabled={enabled} />
    </>
  )
}

export default AlertNotification

const MailIconStyles = `
    height: 25px;
    width: 25px;
    margin-right: 10px;
    margin-top: -3px;
    @media ${screenSize.small} {
        margin-top: 2px;
    }
`
const S = {
  SendCell: styled(Table.Cell)`
    padding-left: 26px;
    font-weight: bold;
    cursor:default;
  `,
  SendMailIcon: styled(MailOutlinedIcon)`
    ${MailIconStyles}
  `,
  UnSendMailIcon: styled(UnsubscribeOutlinedIcon)`
    ${MailIconStyles}
  `
}
